import type { Domain } from '@/types/domain'
import type { Customize } from '@/types/settings'

export enum ActionTypes {
  SETTING_LOADING = 'SETTING_LOADING',
  SETTING_SIDEBAR_COMPACT = 'SETTING_SIDEBAR_COMPACT',
  SETTING_SET_TENANT = 'SETTING_SET_TENANT',
  SETTING_CUSTOMIZE = 'SETTING_CUSTOMIZE',
}

export interface SettingLoadingType {
  type: ActionTypes.SETTING_LOADING
  payload: boolean
}

export interface SettingSidebarCompactType {
  type: ActionTypes.SETTING_SIDEBAR_COMPACT
  payload: boolean
}

export interface SettingSetTenantType {
  type: ActionTypes.SETTING_SET_TENANT
  payload: Domain
}

export interface SettingCustomizeType {
  type: ActionTypes.SETTING_CUSTOMIZE
  payload: Customize
}

export type SettingsActions =
  | SettingLoadingType
  | SettingSidebarCompactType
  | SettingSetTenantType
  | SettingCustomizeType

export function settingLoadingAction(payload: boolean): SettingLoadingType {
  return {
    type: ActionTypes.SETTING_LOADING,
    payload,
  }
}

export function settingSidebarCompactAction(
  payload: boolean,
): SettingSidebarCompactType {
  return {
    type: ActionTypes.SETTING_SIDEBAR_COMPACT,
    payload,
  }
}

export function settingSetTenantAction(payload: Domain): SettingSetTenantType {
  return {
    type: ActionTypes.SETTING_SET_TENANT,
    payload,
  }
}

export function settingCustomizeAction(
  payload: Customize,
): SettingCustomizeType {
  return {
    type: ActionTypes.SETTING_CUSTOMIZE,
    payload,
  }
}
